@if (selectedRoom) {
<div class="col th-p notification-content-wrapper">
  <header class="top-box-shadow topicDetailsView">
    <div class="columns is-gapless is-vcentered is-mobile">
      <figure class="has-text-centered">
        <i
          class="hideDeskViewIcon fa"
          [ngClass]="{
            'fa-chevron-left': !this.staffRoomComponent.viewStaffRoomList,
            'fa-chevron-right': this.staffRoomComponent.viewStaffRoomList
          }"
          (click)="hideRoomList()"
        ></i>
      </figure>
      @if (!editRoomDetails) {
      <div class="column is-7">
        <h3 class="is-marginless is-clearfix">
          <span
            class="is-size-6 has-text-weight-semibold ellipsis"
            style="max-width: 80%; display: inline-block"
            title="{{ selectedRoom.chat_group_name }}"
            >{{ selectedRoom.chat_group_name }}</span
          >
          <!-- <a class="has-text-info" (click)="editRoomName()">
              <i class="fa fa-pencil fa-font-size pad-7-2"></i>
            </a> -->
          <small class="display-b is-size-7 text-clr-grey">{{
            selectedRoom.createdAt | date : "MMM d, y h:mm a"
          }}</small>
        </h3>
      </div>
      }
      <!-- Post name update section -->
      @if (editRoomDetails) {
      <div class="column is-7">
        <div class="control edit-text-box">
          <input
            type="text"
            class="input"
            inputFocus
            placeholder="Type here..."
            size="{{ calcTextLength(editRoomDetails.chat_group_name) }}"
            [(ngModel)]="editRoomDetails.chat_group_name"
            (keyup.enter)="updateRoomName(editRoomDetails)"
          />
          <div class="options">
            <a class="button is-small mar-0-10" (click)="cancelEditedRoom()"
              >Cancel</a
            >
            <a
              class="button is-link is-small"
              (click)="updateRoomName(editRoomDetails)"
              >Save</a
            >
          </div>
        </div>
      </div>
      }
      <div class="column has-text-right">
        <div class="desk-view">
          <div class="tabs is-toggle is-toggle-rounded is-small">
            <!-- <a class="" (click)="openCreateAssign()" style="border-style: initial;">
              <button class="button is-link is-outlined is-small">New Assignment</button>
            </a> -->
            <a class="btnDeskView" (click)="openCreateNewTopic()">
              <button class="button is-link is-outlined is-small">
                <i class="fa fa-plus-cricle" aria-hidden="true"></i> Create
                Topic / Assignment
              </button>
            </a>
            <a class="btnMobileView" (click)="openCreateNewTopic()">
              <button class="button is-link is-outlined is-small">
                <i class="fa fa-plus" aria-hidden="true"></i>
              </button>
            </a>
            <a
              class="btnMobileView isMobiles"
              (click)="closeRightSidebarMobile()"
            >
              <button class="button is-small">
                <i class="fa fa-times" aria-hidden="true"></i>
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </header>
  <div class="contents pos-relative">
    <div
      class="notifications scroll-bar"
      (reachedBottom)="fetchNextTopicList()"
      infinite-scroll
      [infiniteScrollDistance]="modalScrollDistance"
      [infiniteScrollThrottle]="modalScrollThrottle"
      [scrollWindow]="false"
      (scrolled)="fetchNextTopicList()"
    >
      @if (activeListView == true && activeTileView == false) {
      <div class="chat-list mar-0-15">
        <app-topic-list-view
          [RoomTopicList]="getRoomTopicList"
          [topicHighlight]="currentTopic"
          [classRoomId]="groupId"
        ></app-topic-list-view>
      </div>
      }
      <!-- <div class="chat-list msg-list-view" *ngIf="activeListView == false && activeTileView == true">
      <app-topic-tile-view [RoomTopicList]="getRoomTopicList"></app-topic-tile-view>
    </div> -->
      <!-- <pagination-loader [showFetchLoader]="showPaginateSpinner"></pagination-loader> -->
    </div>
  </div>
</div>
}

<div class="showAssignment">
  <!--prepare class-->
  <div
    class="modal scroll-bar"
    [ngClass]="{ 'is-modal-active': domElementControl.showCreateNewRoom }"
    infinite-scroll
    [scrollWindow]="true"
    [infiniteScrollDistance]="modalScrollDistance"
    [infiniteScrollThrottle]="modalScrollThrottle"
    style="border: 3px solid #fff"
  >
    <div class="modal-background"></div>
    <div class="modal-card">
      <div class="card">
        <form [formGroup]="newTopicForm" novalidate>
          <div class="card-header">
            <p class="card-header-title">New Topic / Assignment</p>
            <button
              class="delete"
              aria-label="close"
              (click)="hideTopicModal()"
            ></button>
          </div>
          <div class="card-content scroll-bar pos-relative" infinite-scroll>
            <div class="content">
              <div class="column is-12">
                <div class="columns">
                  <div class="column is-6">
                    <div class="field">
                      <label class="label"
                        >Title
                        <span class="required">*</span>
                      </label>
                      <div class="control">
                        <input
                          type="text"
                          name="topic"
                          class="input"
                          placeholder="Please enter title..."
                          formControlName="topic"
                        />
                        <form-validation
                          [control]="newTopicForm.controls.topic"
                        ></form-validation>
                      </div>
                    </div>
                  </div>
                  <div class="column is-6">
                    <div class="field">
                      <label class="label">Type</label>
                      <div class="control">
                        @for (topic of topicType; track topic; let i = $index) {
                        <label class="radio">
                          <input
                            type="radio"
                            name="staff_type"
                            formControlName="staff_type"
                            [value]="topic.value"
                            [checked]="topic.value == defaultChecked"
                            [(ngModel)]="defaultChecked"
                            (change)="selectedType(i)"
                          />
                          {{ topic.name }}
                        </label>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-6">
                    <div class="field">
                      <label class="label">{{ selectedDateLabel }} </label>
                      <input
                        type="date"
                        id="datePicker"
                        name="schedule_date"
                        class="input"
                        [min]="getToday()"
                        formControlName="schedule_date"
                        (keyup)="isRestrictDate($event)"
                        (keydown)="(false)"
                      />
                    </div>
                  </div>
                  <div class="column is-6">
                    <div class="field">
                      <label class="label">{{ selectedTimeLabel }} </label>
                      <!-- <input type="time" id="datePicker1" name="schedule_time" class="input" [min]="getCurrentTime()" formControlName="schedule_time" (keyup)="isRestrictDate($event)" (keydown)="false"> -->
                      <input
                        [ngxTimepicker]="picker"
                        class="input"
                        name="schedule_time"
                        formControlName="schedule_time"
                        [min]="getCurrentTime()"
                      />
                      <ngx-material-timepicker
                        #picker
                      ></ngx-material-timepicker>
                    </div>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <div class="field post-attach-file">
                      <label
                        class="label newTopicAdd"
                        data-tooltip="Attach only PNG,JPEG,JPG,MP3,MP4,WAV,PDF,PPT,PPTX,PPTM,XML,XLS,XLSX,DOC,DOCX,TXT file"
                        >Attach File
                        <i
                          class="fa fa-info-circle is-size-6"
                          aria-hidden="true"
                        ></i>
                      </label>
                      @if (!preUploadedFile) {
                      <div
                        class="control file is-boxed is-fullwidth is-info-light"
                      >
                        <label class="file-label">
                          <input
                            type="file"
                            name="msg-file"
                            style="display: none"
                            (change)="onChooseFile($event)"
                            #topicFileInput
                            accept=".png, .jpeg, .jpg, .mp3, .mp4, .wav, .pdf, .ppt, .pptx, .pptm, .xml, .xls, .xlsx, .doc, .docx, .txt"
                          />
                          <span class="file-cta">
                            <span class="file-icon">
                              <i class="fa fa-upload"></i>
                            </span>
                            <span class="file-label is-small is-centered">
                              Attach file here…
                            </span>
                          </span>
                        </label>
                      </div>
                      } @if (upLoadedFileList.length > 0) {
                      <div>
                        @for (eachFile of upLoadedFileList; track eachFile) {
                        <div class="pos-relative">
                          <div class="file-detail">
                            <div class="content-align">
                              <p class="is-small">
                                <!-- <img  src="../../../../assets/images/file_types/{{eachFile.mimeType}}.png" width="35px" height="35px">  -->
                                {{ eachFile.name }}
                              </p>
                              <span class="file-size is-small">{{
                                eachFile.size | fileSize
                              }}</span>
                              @if (eachFile.progressVal) {
                              <progress
                                class="progress is-link is-small"
                                value="{{ eachFile.progressVal }}"
                                max="100"
                              ></progress>
                              }
                            </div>
                          </div>
                          <!-- <i class="fa fa-times" aria-hidden="true" (click)="removeFileFromList(eachFile)"></i> -->
                        </div>
                        }
                      </div>
                      }
                    </div>
                    @if (preUploadedFile && uploadAttachFile) {
                    <div class="is-small">
                      @for (f of uploadFileIcons; track f) {
                      <div>
                        @if (f.name===preUploadedFile.file_ext) {
                        <span class="is-small">
                          <img
                            [src]="f.icons"
                            alt=""
                            width="35px"
                            height="35px"
                          />
                          {{ preUploadedFile.file_id }}
                          <button
                            class="delete"
                            aria-label="Delete"
                            (click)="removeUploadFile()"
                          ></button>
                        </span>
                        }
                      </div>
                      }
                    </div>
                    }
                  </div>
                </div>
                <!-- <div class="field" *ngIf="preUploadedFile">
                <div *ngIf="preUploadedFile?.file_type==='video' || preUploadedFile?.file_type==='audio'">
                  <label for="" class="label">Questionnaries URL</label>
                  <div class="control">
                    <input type="text" class="input" name="quest_url" placeholder="Enter Questionnaries URL">
                  </div>
                </div>
              </div> -->
                <div class="field">
                  <label class="label">Description</label>
                  <angular-editor
                    class="scroll-bar"
                    formControlName="notes"
                    [config]="editorConfig"
                    cols="10"
                    rows="2"
                    maxlength="500"
                  ></angular-editor>
                  @if (newTopicForm.controls.notes) {
                  <p class="help is-danger">
                    Message length must be less than 500 characters
                  </p>
                  }
                </div>
              </div>
            </div>
          </div>
          <footer class="modal-card-foot">
            <div class="column is-12 has-text-right is-small">
              <button
                type="button"
                class="button mar-0-5 is-small"
                [disabled]="upLoadedFileList.length > 0"
                (click)="hideTopicModal()"
              >
                Cancel
              </button>
              @if (!showBtnSpinner) {
              <button
                type="button"
                class="button is-link is-small hideBtnUpload"
                [disabled]="
                  (newTopicForm.valid && !newTopicForm.dirty) ||
                  newTopicForm.invalid
                "
                (click)="createNewTopic(newTopicForm.value)"
              >
                Create
              </button>
              } @if (showBtnSpinner) {
              <a
                class="button is-link is-loading is-small"
                style="min-width: 100px"
              ></a>
              }
            </div>
          </footer>
        </form>
      </div>
    </div>
  </div>
</div>

<router-outlet></router-outlet>
